import { listEventTimeSlots } from '../../api/listEventTimeSlots/listEventTimeSlots';
import { AsyncComponentDataStatus } from '../../../components/DailyAgenda/state/types';
import { getLocalDateFromDateTime } from '@wix/bookings-catalog-calendar-viewer-utils/dateAndTime';
import type { IHttpError } from '@wix/http-client';
import { InitiatorsArgs } from '../initWidgetData';
import { TriggeredByOptions } from '../../../utils/bi/consts';
import { Service } from '@wix/ambassador-bookings-services-v2-service/types';

export const initAvailableDays = async (
  { flowAPI, setState, getState, biLogger }: InitiatorsArgs,
  triggeredBy: TriggeredByOptions,
) => {
  const { selectedFilters, selectedRange, selectedTimezone, services } =
    getState();
  try {
    const { timeSlots } = await listEventTimeSlots({
      flowAPI,
      timeSlotsPerDay: 1,
      limit: 7,
      filters: selectedFilters,
      range: selectedRange,
      timeZone: selectedTimezone,
      serviceIds: Object.keys(services.data as Record<string, Service>),
    });
    if (!timeSlots || timeSlots.length === 0) {
      setState({
        availableDays: {
          status: AsyncComponentDataStatus.ERROR,
          data: 'No available days found',
        },
      });
      biLogger?.reportDatePickerLoad(timeSlots, triggeredBy);
      return;
    }

    const availableDays = timeSlots.map((slot) =>
      getLocalDateFromDateTime(new Date(slot.localStartDate!)),
    );

    setState({
      availableDays: {
        status: AsyncComponentDataStatus.IDLE,
        data: availableDays,
      },
    });
  } catch (error) {
    setState({
      availableDays: {
        status: AsyncComponentDataStatus.ERROR,
        data: (error as IHttpError).response?.data,
      },
    });
    console.error('Error initializing available days:', error);
  }
};
